import { render, staticRenderFns } from "./sleep-period.vue?vue&type=template&id=c3899982&scoped=true"
import script from "./sleep-period.vue?vue&type=script&lang=js"
export * from "./sleep-period.vue?vue&type=script&lang=js"
import style0 from "./sleep-period.vue?vue&type=style&index=0&id=c3899982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3899982",
  null
  
)

export default component.exports